export default "__VITE_ASSET__f761b126__"